import { Button, Card, CardContent } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import aktivierungPreview from '../assets/aktivierung-preview.png';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AktivierenDialog } from '../components/AktivierenDialog.tsx';
import { useState } from 'react';

const CHECKLIST = ['check1', 'check2'] as const;

export function AktivierungPage() {
  const { t } = useTranslation();
  const [aktivierenOffen, setAktivierenOffen] = useState(false);

  return (
    <div className="p-4 md:p-10 2xl:max-w-screen-2xl 2xl:mx-auto">
      <Card>
        <CardContent className="grid grid-cols-1 gap-10 p-5 md:grid-cols-2 md:p-8">
          <div className="flex h-full flex-col">
            <p className="text-sm font-semibold text-primary-blue-600">
              {t('domain.e2nApi.aktivierung.title')}
            </p>
            <h1 className="mt-2 text-2xl font-extrabold text-neutrals-900">
              {t('domain.e2nApi.aktivierung.subtitle')}
            </h1>
            <p className="mt-4 text-sm text-neutrals-800">
              {t('domain.e2nApi.aktivierung.description')}
            </p>

            <ul className="mt-8 flex flex-col gap-3">
              {CHECKLIST.map((key) => (
                <li key={key} className="flex items-center gap-3">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-blue-100">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-primary-blue-600"
                    />
                  </span>
                  <span className="text-sm text-neutrals-800">
                    {t(`domain.e2nApi.aktivierung.${key}`)}
                  </span>
                </li>
              ))}
            </ul>

            <Button
              className="mt-8 w-full md:w-auto md:self-start"
              onClick={() => setAktivierenOffen(true)}>
              {t('domain.e2nApi.aktivierung.button')}
            </Button>

            <p className="mt-auto pt-8 text-xs text-neutrals-700">
              {t('domain.e2nApi.aktivierung.footerText')}
            </p>
          </div>

          <img
            src={aktivierungPreview}
            alt=""
            className="hidden w-full md:block"
          />
        </CardContent>
      </Card>

      <AktivierenDialog
        open={aktivierenOffen}
        onOpenChange={setAktivierenOffen}
      />
    </div>
  );
}
